export default {
  props: {
    value: {
      type: [Boolean, Number, String],
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    trueValue: {
      type: [Boolean, Number, String],
      default: true
    },
    falseValue: {
      type: [Boolean, Number, String],
      default: false
    },
    trueTitle: String,
    falseTitle: String,
    error: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'medium',
      validator (size) {
        return ['small', 'medium'].indexOf(size) !== -1
      }
    },
    containerSize: {
      type: String,
      validator (size) {
        return !size || ['small', 'medium', null].indexOf(size) !== -1
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    color: String,
    strictComparison: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    innerValue: {
      get () {
        return this.value
      },
      set (value) {
        if (this.disabled) return
        this.$emit('input', value)
      }
    },
    isActive () {
      if (this.strictComparison) return this.value === this.trueValue
      return Boolean(this.value)
    },
    classList () {
      const classList = [
        `size-${this.size}`,
        {
          error: this.error,
          active: this.isActive,
          disabled: this.disabled
        }
      ]

      if (this.containerSize) classList.push(`container-size-${this.containerSize}`)

      return classList
    },
    valueTitle () {
      return this.isActive ? this.trueTitle : this.falseTitle
    },
    hasTitle () {
      return Boolean(this.title || (this.trueTitle && this.falseTitle) || this.$slots.default)
    },
    backgroundColor () {
      if (!this.isActive) return
      return `background-color:${this.color};border-color:${this.color};`
    }
  },
  methods: {
    toggleValue () {
      this.innerValue = this.isActive ? this.falseValue : this.trueValue
    }
  }
}
